/**
 * A basic task's one button in a step's list (P-31, #113; Jason, 2026-10-27: "these done buttons asked to be pushed - if
 * the thing is done, and can be restarted, it should be a greyed out button that is like "reopen" this should apply to all
 * basic tasks"): not done, Mark it done, a button to press; done, a quiet grey Reopen that takes it back to not started.
 * Never drawn pressed or solid black: a task done asks for nothing. Its words say what pressing it does, so it carries no
 * `aria-pressed`. On a completed job a task done stays done (L-30): its Reopen is held back, its title saying why.
 */
export interface TaskToggle {
  words: 'Mark it done' | 'Reopen';
  /** The state pressing it sets. */
  to: 'done' | 'not_started';
  /** Its classes: the bordered button of a step's list, grey once done. */
  look: string;
}

const BASE = 'min-h-9 shrink-0 rounded-[2px] border px-3 text-[0.8125rem] transition-colors duration-[120ms] disabled:cursor-not-allowed';
const REOPEN = `${BASE} border-rule bg-inset text-ink-3 hover:border-rule-strong hover:text-ink-2`;

export function taskToggle(done: boolean): TaskToggle {
  return done
    ? { words: 'Reopen', to: 'not_started', look: REOPEN }
    : { words: 'Mark it done', to: 'done', look: `${BASE} border-rule-strong text-ink-2 hover:border-ink hover:text-ink` };
}

/**
 * A step's own Done, once it is (P-31; Jason, 2026-10-28, of the step's Done: "yes and it goes back to underway"): the same
 * quiet grey Reopen, in place of its row of states, taking it back under way. A milestone, which has no under way, goes
 * back to Not yet, as does a step held by a gate or inspection before it, which goes under way only once that is passed
 * (L-17 B).
 */
export function stepReopen(step: { milestone: boolean; held: boolean }): { to: 'in_progress' | 'not_started'; look: string } {
  return { to: step.milestone || step.held ? 'not_started' : 'in_progress', look: REOPEN };
}
